import React from 'react';
import { isJson } from 'utils';

const DeliveringGift = {
  Info: ({ data }) => {
    const { description } = data.giftTransaction;
    const isValidJson = isJson(description);
    const parseDes = isValidJson
      ? JSON.parse(description)
      : { fullname: '', phone: '', shipAdsress: '' };
    return (
      <div className='flex justify-between'>
        <div className='grow text-14px text-7B7B7B lg:mx-8'>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p>Trạng thái</p>
            <p className='text-009565'>
              {data.giftTransaction.status === 'Delivered'
                ? 'Giao quà thành công'
                : 'Đang giao quà'}
            </p>
          </div>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p>Số lượng đổi quà</p>
            <p className='text-black'>{data.giftTransaction.quantity}</p>
          </div>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p>Hotline</p>
            <p className='text-black'>1900 299 232</p>
          </div>
          <div className='h-3 w-full bg-[#f1f4fb]'></div>
          <p className='font-averta-bold leading-5 text-black'>Thông tin người nhận</p>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p>Họ và tên</p>
            <p className='text-black'>{parseDes?.fullName}</p>
          </div>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p>Số điện thoại</p>
            <p className='text-black'>{parseDes?.phone}</p>
          </div>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p className='mr-6 whitespace-nowrap'>Địa chỉ</p>
            <p className='max-w-[80%] text-right text-black'>{parseDes?.shipAddress}</p>
          </div>
          <div className='my-2 mt-3 flex w-full justify-between'>
            <p className='mr-6 whitespace-nowrap'>Ghi chú</p>
            <p className='max-w-[80%] text-right text-black'>{parseDes?.note}</p>
          </div>
        </div>
        <div className='hidden lg:block'>
          <img
            className='h-[313px] w-[384px] rounded-lg'
            src={data?.imageLinks[0]?.fullLink || ''}
            alt=''
          />
        </div>
      </div>
    );
  },
  Confirm: ({ handleChangeGift }) => {
    return (
      <div className='absolute bottom-0 flex h-[58px] w-full items-center justify-center border-t bg-f5f5f5 py-2'>
        <button
          className='my-auto h-[42px] rounded-4px bg-gradient-blue px-20 font-averta-semibold text-14px uppercase text-white '
          onClick={handleChangeGift}
        >
          Xác nhận nhận quà
        </button>
      </div>
    );
  },
  FillInInformation: ({ fillInInformation }) => {
    return (
      <div className='absolute bottom-0 flex h-[58px] w-full items-center justify-center border-t bg-f5f5f5 py-2'>
        <button
          className='my-auto h-[42px] rounded-4px bg-gradient-blue px-20 font-averta-semibold text-14px uppercase text-white '
          onClick={fillInInformation}
        >
          Nhập thông tin để nhận GYCBH
        </button>
      </div>
    );
  },
};

export default DeliveringGift;
